import { api } from '@/lib/api/client';
import type { EcInvoicePlan, EcPlan, StripeCheckoutSession } from '@/lib/api/types';

/**
 * Billing API.
 *
 * Backend routes (ox-platform):
 *   GET  /plans/catalog                       → sellable plans (public, NO company filter)
 *   GET  /ec-invoice-plans                    → invoices (auth)
 *   POST /plans/checkout                      → REAL Stripe Checkout (auth)
 *   GET  /plans/checkout/confirm/:sessionId   → webhook poll (auth, see BillingSuccessPage)
 *
 * NOTE: `/ec-plans` (legacy list) filters by request companyId via BaseService,
 * so global catalog rows with `companyId IS NULL` come back empty for tenant
 * users. The pricing page must hit `/plans/catalog` instead.
 */
// Which app's catalog this build is wired to. Reads VITE_APP (already used by
// auth) so the same SDK boot value drives pricing too. Defaults to xotski.
const APP_SLUG = (import.meta.env.VITE_APP as string | undefined) ?? 'xotski';

export const billingApi = {
  listPlans: async () => {
    const items = await api.get<EcPlan[]>(
      `/plans/catalog?app=${encodeURIComponent(APP_SLUG)}`,
    );
    return { items, total: items.length };
  },
  listInvoices: () => api.list<EcInvoicePlan>('/ec-invoice-plans'),

  createCheckout: (planId: number) =>
    api.post<StripeCheckoutSession>('/plans/checkout', {
      planId,
      // /billing/stripe-success y no /billing/success: la primera es la que
      // hace POLLING del webhook (BillingSuccessPage) hasta ver el plan
      // aplicado; la segunda era estática y la compra parecía no aplicar.
      successUrl: `${window.location.origin}/billing/stripe-success?session_id={CHECKOUT_SESSION_ID}`,
      cancelUrl: `${window.location.origin}/pricing`,
    }),
};
